"use strict";
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.sectionToUrlPath = void 0;
const sectionToUrlPath = (section) => {
    if (!section.iterationContext || section.iterationContext.length === 0) {
        return section.sectionShortname;
    }
    return `${section.sectionShortname}/${section.iterationContext.join('/')}`;
};
exports.sectionToUrlPath = sectionToUrlPath;
//# sourceMappingURL=NavigationTypes.js.map